// extracted by mini-css-extract-plugin
module.exports = {"smallPrint":"PolicyDescription_smallPrint__L0oIP","link":"PolicyDescription_link__8l7uX"};